import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyPageMeta, PageMetaInput, resolvePageMeta } from './siteMeta';

type PageMetaProps = Partial<PageMetaInput>;

export function PageMeta({
  title,
  description,
  path,
  keywords,
  robots,
  ogType,
  noindex,
}: PageMetaProps = {}) {
  const { pathname } = useLocation();

  useEffect(() => {
    applyPageMeta(
      resolvePageMeta(pathname, {
        title,
        description,
        path,
        keywords,
        robots,
        ogType,
        noindex,
      })
    );
  }, [pathname, title, description, path, keywords, robots, ogType, noindex]);

  return null;
}

export function usePageMeta({
  title,
  description,
  path,
  keywords,
  robots,
  ogType,
  noindex,
}: Partial<PageMetaInput>): void {
  const { pathname } = useLocation();

  useEffect(() => {
    applyPageMeta(
      resolvePageMeta(pathname, {
        title,
        description,
        path,
        keywords,
        robots,
        ogType,
        noindex,
      })
    );
  }, [pathname, title, description, path, keywords, robots, ogType, noindex]);
}
